module.exports = __webpack_public_path__ + "static/media/surveys-notification-icon.7083507d.svg";